// extracted by mini-css-extract-plugin
module.exports = {"modalWrap":"_2cU42","modalHeaderWrap":"xqlZ3","modalHeader":"_3cB9T","modalSubheading":"_2x5zA","close":"_1eKYB","scaleWrapper":"jsGrr"};